export default "__VITE_ASSET__57598224__"